var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column align-start",class:this.$store.rdiStore.state.selectedType === 2 || this.$store.rdiStore.state.selectedType === 3 ? 'scrollable-list-bak':'',attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('FullHeader'),_c('RdiContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }